import { Edit } from '@mui/icons-material'
import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'

export const EditCustom = styled(Edit)<IconStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor }) => cursor || 'pointer'};
  color: ${({ colorIcon }) => colorIcon || COLORS.black};
`
